export enum PopupState {
  IDLE = 'IDLE',
  CLOSED = 'CLOSED',
  STARTED = 'STARTED',
  VISIBLE = 'VISIBLE',
  SEEN = 'SEEN',
}
